import { useForm, FormProvider } from 'react-hook-form';
import "./Form.scss";
import { forwardRef, useCallback, useEffect, useImperativeHandle } from 'react';

const Form = ({children, className='', onSubmit, onChange}, ref) => {
    const methods = useForm({mode: 'onChange'});

    const {watch} = methods;

    // pokud potrebujeme kontrolovat kazdou zmenu
    const debouncedOnChange = useCallback(() => {
        const subscription = watch((value) => {
            clearTimeout(debouncedOnChange.timer);
            debouncedOnChange.timer = setTimeout(() => {
                onChange(value);
            }, 1000);
        });
        return () => subscription.unsubscribe(); 
    }, [watch, onChange]);

    useEffect(() => {
        if (typeof onChange === 'function') {
            const unsubscribe = debouncedOnChange();
            return () => {
                clearTimeout(debouncedOnChange.timer); 
                unsubscribe(); 
            };
        }
    }, [watch])
    // 

    useImperativeHandle(ref, ()=>({...methods}), [methods])


    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} className={'superform '+ className}>
                {children}
            </form>
        </FormProvider>
    )
}

export default forwardRef(Form);